import type { TranslateFn } from "#/lib/i18n.js";
import { BrandLogo, getLocalizedHref } from "./shared.js";

export function FooterEditorialLongform({ locale, t }: { locale: string; t: TranslateFn }) {
  return (
    <footer
      data-public-chrome="footer"
      className="mt-16 border-t border-[color:var(--color-border-subtle)] bg-[color:var(--color-bg-surface)]"
    >
      <div className="mx-auto grid max-w-7xl gap-6 px-4 py-8 sm:px-6 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:px-8">
        <div>
          <BrandLogo href={getLocalizedHref(locale, "/")} t={t} size="sm" />
          <p className="mt-3 max-w-prose text-sm leading-7 text-[color:var(--color-fg-muted)]">
            {t("chrome.footer.description")}
          </p>
        </div>
        <div>
          <h2 className="font-serif text-xl text-[color:var(--color-fg-default)]">
            {t("chrome.footer.aboutReport")}
          </h2>
          <p className="mt-3 text-sm leading-7 text-[color:var(--color-fg-muted)]">
            {t("chrome.footer.editorialDesk")}
          </p>
        </div>
      </div>
    </footer>
  );
}
